
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    '产品系列': [
      { name: '内调·轻养计划', path: '/products/light-care' },
      { name: '内调·臻养计划', path: '/products/premium-care' },
      { name: '外养·肌密计划', path: '/products/skin-care' },
      { name: '节令尊享', path: '/products/seasonal' }
    ],
    '服务支持': [
      { name: '体质测试', path: '/assessment' },
      { name: '御医定制', path: '/custom-service' },
      { name: '用户指南', path: '/guide' },
      { name: '常见问题', path: '/faq' }
    ],
    '关于我们': [
      { name: '品牌故事', path: '/story' },
      { name: '养森体验', path: '/experience' },
      { name: '合作伙伴', path: '/partners' },
      { name: '联系我们', path: '/contact' }
    ]
  };

  return (
    <footer className="bg-stone-900 text-stone-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-8 py-20">
        <div className="grid lg:grid-cols-4 gap-16">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-4 mb-8">
              <img
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/a9def463ca32930876b6ebe479fd9734.png"
                alt="宫廷养森"
                className="w-12 h-12 object-contain"
              />
            </div>

            <p className="text-xs lg:text-sm text-stone-400 leading-relaxed mb-8">
              传承千年宫廷古方，融合现代中医智慧，为您呈现内调外养的完整解决方案。
            </p>

            {/* Social Links */}
            <div className="flex space-x-4">
              <a href="#" className="w-12 h-12 bg-stone-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer transform hover:scale-110">
                <i className="ri-wechat-line text-lg text-stone-300 hover:text-white"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-stone-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer transform hover:scale-110">
                <i className="ri-tiktok-line text-lg text-stone-300 hover:text-white"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-stone-800 hover:bg-red-600 rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer transform hover:scale-110">
                <img 
                  src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/e741302b15a5a780f7de5127314fcccd.png" 
                  alt="小红书" 
                  className="w-5 h-5 object-contain filter brightness-0 invert opacity-75 hover:opacity-100 transition-opacity duration-300"
                />
              </a>
            </div>

          </div>

          {/* Links Sections - Hidden on mobile */}
          <div className="hidden lg:block lg:col-span-3">
            <div className="grid lg:grid-cols-3 gap-16">
              {Object.entries(footerLinks).map(([title, links]) => (
                <div key={title}>
                  <h4 
                    className="text-sm lg:text-base font-medium text-white mb-8"
                    style={{ fontFamily: 'Noto Serif SC, serif' }}
                  >
                    {title}
                  </h4>
                  <ul className="space-y-4">
                    {links.map((link) => (
                      <li key={link.name}>
                        <Link
                          to={link.path}
                          className="text-xs lg:text-sm text-stone-400 hover:text-red-400 transition-colors duration-300 cursor-pointer"
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-8 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <div className="flex flex-wrap md:flex-nowrap items-center space-x-4 md:space-x-8 text-xs text-stone-400">
              <span>© {currentYear} 宫廷养森. 保留所有权利.</span>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-red-400 transition-colors duration-300 cursor-pointer"
              >
                Website Builder
              </a>
            </div>
            
            {/* Certifications */}
            <div className="flex items-center space-x-6 text-xs text-stone-500">
              <span className="flex items-center space-x-2">
                <i className="ri-shield-check-line"></i>
                <span>安全认证</span>
              </span>
              <span className="flex items-center space-x-2">
                <i className="ri-award-line"></i>
                <span>品质保证</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
